export async function urlToFile(
  url: string,
  filename: string,
  mimeType: string = "image/jpeg"
): Promise<File> {
  let lastError: unknown = null
  const attempts = 2

  for (let attempt = 0; attempt < attempts; attempt++) {
    try {
      const res = await fetch(url, {
        method: "GET",
        mode: "cors",
        cache: "no-store",
        credentials: "omit",
      })
      if (!res.ok) throw new Error(`Failed to fetch image: ${res.status}`)
      const blob = await res.blob()
      const file = new File([blob], filename, { type: blob.type || mimeType })
      return file
    } catch (e) {
      lastError = e
      if (attempt < attempts - 1) {
        await new Promise((r) => setTimeout(r, 250 * (attempt + 1)))
      }
    }
  }

  throw lastError
}
